module.exports = __webpack_public_path__ + "media/pages/Home/images/Landing_Group-bf8cdaf31267714df446a7fe24f2fd91.jpg";